import { Component, OnInit, Input } from '@angular/core';
import ArrayList from "../../../models/ArrayList";
import ActivityLog from "../../../models/ActivityLog";

@Component({
  selector: 'app-log-history',
  templateUrl: './log-history.component.html',
  styleUrls: ['./log-history.component.scss']
})
export class LogHistoryComponent implements OnInit {

  @Input() logs: ArrayList<ActivityLog>;

  public numShown = 3;
  constructor() {
    console.log(this.logs);
  }

  ngOnInit() {
  }

  toggleShowAll() {
    if (this.numShown === 3) {
      this.numShown = this.logs.getSize();
    } else {
      this.numShown = 3;
    }
  }

}
